export const postMessageToParent = (data) => {
    window.parent.postMessage(data, { targetOrigin: "*" })
}